module.exports = __webpack_public_path__ + "nemonics-8116b7fb.webp";